import A11yDialog from 'a11y-dialog'

$('.modal-container').each(function(){
    var id = $(this).attr('id');

    var container = document.getElementById(id)
    var dialog = new A11yDialog(container)

    dialog.on('show', function (element, event) {
        $('body').addClass('__blur')
    })

    dialog.on('hide', function (element, event) {
        $('body').removeClass('__blur')
    })
})
